// Open-redirect guard. Only same-origin, absolute pathname targets are allowed.
// Refuses: external URLs, protocol-relative ("//evil"), JS pseudo-URLs,
// path-traversal sequences, and anything that does not start with a single "/".

const DEFAULT_FALLBACK = '/dashboard';

/**
 * sessionStorage key carrying a post-login `redirect` target across the Google
 * OAuth round-trip — set by GoogleSignInButton before leaving for Google,
 * consumed by AuthCallbackPage on return. sessionStorage survives the
 * same-origin OAuth redirect (same tab).
 */
export const POST_AUTH_REDIRECT_STORAGE_KEY = 'ddm.postAuthRedirect';

export function safeRedirectTarget(
  raw: string | null | undefined,
  fallback: string = DEFAULT_FALLBACK,
): string {
  if (!raw) return fallback;
  if (typeof raw !== 'string') return fallback;
  if (!raw.startsWith('/')) return fallback;
  if (raw.startsWith('//')) return fallback; // protocol-relative
  if (raw.startsWith('/\\')) return fallback; // backslash trick, IE-era safety
  if (/^\s*$/.test(raw)) return fallback;
  if (raw.toLowerCase().includes('javascript:')) return fallback;
  if (raw.includes('\n') || raw.includes('\r')) return fallback;
  // Disallow path traversal that escapes the app root.
  if (raw.includes('..')) return fallback;
  return raw;
}
